import CrudManager from '@/components/admin/CrudManager';

const fields = [
    { key: 'name', label: 'Name', type: 'text' },
    { key: 'category', label: 'Category', type: 'text', placeholder: 'e.g. Association, Government Registry, Industry Network' },
    { key: 'logo_url', label: 'Logo', type: 'upload-image', prefix: 'associations' },
    { key: 'description', label: 'Description', type: 'textarea', rows: 2 },
    { key: 'website', label: 'Website', type: 'text' },
    { key: 'order', label: 'Order', type: 'number' },
];

const columns = [
    { key: 'name', label: 'Name', primary: true },
    { key: 'category', label: 'Category' },
];

const defaultItem = { name: '', category: 'Association', logo_url: '', description: '', website: '', order: 99 };

export default function AdminAssociationsPage() {
    return (
        <CrudManager
            resource="associations"
            title="Associations / Networks"
            description="Organisations we are connected with (shown on About Us)."
            fields={fields}
            columns={columns}
            defaultItem={defaultItem}
            searchKeys={['name', 'category']}
        />
    );
}
